import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../loader/loader.component';
import { ANGULAR_MODULES } from '../shared-imports';
import { GeneralService } from 'src/app/services/general.service';
import { lastValueFrom, Subject, take, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { UserService } from 'src/app/services/User.service';
import { SharedHTMLSettingsDataService } from '../sharedHTMLSettingsData.service';

@Component({
  selector: 'app-passcodeAuth',
  templateUrl: './passcode-Authentication.component.html',
  imports: [ANGULAR_MODULES, LoaderComponent],
})
export class PassCodeAuthentication implements OnInit, OnDestroy {

    @Output() passcodeAuthenciate = new EventEmitter<any>();
    @ViewChild('passCodeInput', { static: false }) passcodeElementRef!: ElementRef
    public loaderIcon: Promise<boolean>;
    passcode: string = '';
    enteredBy: number = null;
    private destroy$ = new Subject<void>();
    userList: any[] = [];
    defaultLoggedInUser = null;

    constructor(private toastr: ToastrService,
        private generalService: GeneralService,
        private userService: UserService,
        private sharedHTMLSettings: SharedHTMLSettingsDataService,
    ) { }

    ngOnInit(): void {
        this.loadUserList();
    }

    ngOnDestroy(): void {
    }

    OpenModal() {
      this.sharedHTMLSettings.openModalById('authModal');
      setTimeout(() => {
        this.passcodeElementRef.nativeElement.focus();
      }, 500);
    }
    
  async loadUserList() {
    const userData = await lastValueFrom(
      this.generalService.getLoggedInUserAndTerminal().pipe(take(1))
    );
    this.defaultLoggedInUser = userData.UserId;
    this.userService.getUserList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (users) => {
          this.userList = users;
          this.enteredBy = userData.UserId;
        },
        error: (err) => {
        }
      });
  }

    submitAuth() {
      const passcode = this.passcode;
      const userId = this.enteredBy;
  
      this.generalService.authenticatePasscodeForUsers(userId, passcode).pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            if (res && res.Success) {
              this.sharedHTMLSettings.closeModalById('authModal');
              this.passcodeAuthenciate.emit(true);
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Invalid Passcode',
                text: 'Please enter a valid passcode to proceed.',
                confirmButtonText: 'OK',
              });
              this.passcodeAuthenciate.emit(false);
            }
            this.passcode = "";
            this.enteredBy = this.defaultLoggedInUser;
          },
          error: (err) => {
              this.passcodeAuthenciate.emit(false);
          }
        });
    }

    closeModalById(modalId) {
        this.sharedHTMLSettings.closeModalById(modalId);
        this.passcodeAuthenciate.emit(false);
    }

}
